/*
 * Usage: <InjectColorFilter name="primary" />
 * <Icon className="filter-[url(#primary-color-filter)]" />
 */

export const InjectColorFilter = ({
	name,
	color,
}: {
	name: string;
	color?: string;
}) => {
	return (
		<svg
			width="0"
			height="0"
			aria-hidden
			aria-label="Color filters"
			className="sr-only"
		>
			<defs>
				<filter id={`${name}-color-filter`} colorInterpolationFilters="sRGB">
					<feFlood
						result="flood"
						style={{ floodColor: color ?? `var(--${name})` }}
					/>
					<feComposite in="flood" in2="SourceAlpha" operator="in" />
				</filter>
			</defs>
		</svg>
	);
};
